export interface IPrepareHeatmapParams {
  lat: number
  lon: number
  frq: number
  rad: number
  alt?: number // elevation above ground (not sea level) (meters)
  txw?: number // transmission power in the units given by power_units
  power_units?: 'W' | 'KW' | 'MW' | 'GW' | null // unit of txw; null/undefined = watts
}

/** Convert a power value to watts given its unit string from the station class record. */
const toWatts = (power: number, units: 'W' | 'KW' | 'MW' | 'GW' | null | undefined): number => {
  switch (units) {
    case 'KW':
      return power * 1_000
    case 'MW':
      return power * 1_000_000
    case 'GW':
      return power * 1_000_000_000
    default:
      return power // 'W', null, undefined — treat as watts
  }
}

// N.B. If you change this, you should change the same function on the backend as well.
const prepareHeatmapParams = (
  { lat, lon, frq, rad, alt, txw, power_units }: IPrepareHeatmapParams,
  receiver?: any,
) => ({
  site: 'A1',
  network: 'Testing',
  transmitter: {
    lat,
    lon,
    alt: alt == null ? 2 : alt,
    frq,
    txw: txw != null ? toWatts(txw, power_units) : 10,
    bwi: 10,
  },
  receiver: receiver || {
    alt: 2,
  },
  antenna: {
    txg: 1.5,
    txl: 1,
    ant: 'cosine',
    azi: 90,
    tlt: 2,
    hbw: 90,
    vbw: 20,
    fbr: null,
    pol: 'v' as const,
  },
  output: {
    units: 'm', // Choices are m (meters above ground level, kilometer distances), m_amsl (meters above sea level, kilometer distances), f (feet above ground level, mile distances), f_amsl (feet above sea level, mile distances). Default is m. See https://cloudrf.com/documentation/developer/#/Create/area
    col: 'RAINBOW.dBm',
    out: 2,
    ber: 2,
    mod: 7,
    nf: -100,
    res: 10,
    rad,
  },
})

export default prepareHeatmapParams
